export const name = 'triggersAndReactions' as const
